export enum ProspectUpdatedAtBucketEnum {
  recent = 'recent', // updatedAt within last 2 months
  mid = 'mid', // updatedAt > 2 months and <= 18 months
  stale = 'stale' // updatedAt > 18 months
}
